import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Container,
  Typography,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  TrendingUp,
  EmojiEventsOutlined,
  PeopleOutline,
} from "@material-ui/icons";

import { SignUpForm } from "../Signup";
import { SignInLink } from "../Signin";
import CompanyLogo from "../CompanyLogo";
import { brand } from "../StyledComponents/theme";

const useStyles = makeStyles((theme) => ({
  hero: {
    padding: theme.spacing(7, 3, 1),
    textAlign: "center",
  },
  tagline: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4),
  },
  heroSide: {
    [theme.breakpoints.up("md")]: {
      paddingRight: theme.spacing(5),
    },
  },
  valueProp: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: theme.spacing(3.5),
  },
  valueIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 44,
    height: 44,
    borderRadius: "50%",
    backgroundColor: brand.orangeTint,
    color: brand.orange,
    marginRight: theme.spacing(2),
    flexShrink: 0,
  },
  signupCard: {
    padding: theme.spacing(3.5, 3.5, 1),
  },
  footer: {
    textAlign: "center",
    padding: theme.spacing(4, 0, 6),
  },
}));

const ValueProp = ({ icon, title, description }) => {
  const classes = useStyles();
  return (
    <div className={classes.valueProp}>
      <div className={classes.valueIcon}>{icon}</div>
      <div>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2">{description}</Typography>
      </div>
    </div>
  );
};

const Home = () => {
  const classes = useStyles();

  return (
    <Container fixed>
      <div className={classes.hero}>
        <CompanyLogo size="sm" height="90" />
        <Typography variant="h1">Smart Squirrel</Typography>
        <Typography variant="subtitle1" className={classes.tagline}>
          The Emergency Savings Incentive Program. Save a little every week,
          win real prizes.
        </Typography>
      </div>
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} md={5} className={classes.heroSide}>
          <Box pt={{ xs: 0, md: 4 }}>
            <ValueProp
              icon={<TrendingUp />}
              title="More savings"
              description="Build your emergency fund automatically, one week at a time."
            />
            <ValueProp
              icon={<EmojiEventsOutlined />}
              title="Win prizes"
              description="Every week you save, you're entered in the sweepstakes — with a bigger quarterly drawing."
            />
            <ValueProp
              icon={<PeopleOutline />}
              title="Challenge coworkers"
              description="Save alongside your team and celebrate the wins together."
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={5}>
          <Card>
            <CardContent className={classes.signupCard}>
              <Box mb={2}>
                <Typography variant="h4">Create your account</Typography>
              </Box>
              <SignUpForm />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <div className={classes.footer}>
        <SignInLink />
      </div>
    </Container>
  );
};

export default Home;
